module.exports = __webpack_public_path__ + "img/company6-2.e2411e26.jpg";